var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"btn-color",class:{
    selected: _vm.selected,
    disabled: _vm.disabled,
  },style:(_vm.customStyle),on:{"click":function($event){return _vm.$emit('click')}}},[(_vm.isShowCancelIcon)?_c('img',{attrs:{"src":require("@/assets/icon/icon-disabled-color.png")}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }